
import { UnitConverter } from "@/components/UnitConverter";
import { Helmet } from "react-helmet";

const Index = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "UnitCodex - Historical Unit Conversion",
    "description": "Convert between modern and historical units of measurement. Learn about the fascinating history of measurement systems.",
    "applicationCategory": "UtilityApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "124"
    },
    "featureList": "Historical unit conversion, Measurement history, Education resources"
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How do I convert a cubit to meters?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "To convert from cubits to meters, multiply the cubit value by 0.4572. One ancient Egyptian cubit is approximately equal to 0.4572 meters."
        }
      },
      {
        "@type": "Question",
        "name": "What is the difference between Imperial and Metric systems?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The Imperial system (used primarily in the US) is based on historically arbitrary units, while the Metric system (used in most countries) is based on decimal calculations and scientific standards. Metric units are easier to convert since they use powers of 10."
        }
      },
      {
        "@type": "Question",
        "name": "How old are measurement systems?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Measurement systems date back to ancient civilizations. The Egyptian cubit is over 5,000 years old, based on the length from elbow to extended fingertips. Ancient Mesopotamians, Egyptians, and Romans all developed sophisticated measurement systems for trade, construction and land measurement."
        }
      }
    ]
  };
  
  return (
    <div className="py-12">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <div className="container">
        <header className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-cinzel text-manuscript-primary mb-3 
                         relative inline-block after:absolute after:w-1/2 after:h-0.5 
                         after:bg-gradient-to-r after:from-manuscript-secondary/80 after:via-manuscript-secondary 
                         after:to-transparent after:bottom-0 after:left-1/4">
            Historical Unit Conversion
          </h1>
          <p className="text-manuscript-primary/80 max-w-2xl mx-auto mt-4 text-lg">
            Discover and convert historical units of measurement from across the ages. 
            Explore the fascinating history behind ancient and modern measurement systems.
          </p>
        </header>

        <UnitConverter />

        <div className="max-w-3xl mx-auto mt-16 py-6">
          <div className="rounded-lg overflow-hidden bg-white/80 backdrop-blur-sm shadow-md 
                        transition-all duration-300 hover:shadow-lg border border-manuscript-primary/10">
            <div className="aspect-w-16 aspect-h-9 relative">
              <div className="absolute inset-0 flex items-center justify-center">
                <img 
                  src="/lovable-uploads/16fd30a4-b661-4e75-9eff-78d698fdcf53.png" 
                  alt="Historical measuring devices including cubit rods, rulers, and ancient scales" 
                  className="max-w-full h-auto"
                />
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6 
                              bg-gradient-to-t from-manuscript-primary/90 via-manuscript-primary/70 to-manuscript-primary/30">
                  <h2 className="text-xl md:text-3xl font-cinzel text-white mb-3 shadow-text font-bold">
                    Historical Measurement Instruments
                  </h2>
                  <p className="text-white text-base md:text-lg max-w-md shadow-text font-medium">
                    Explore the fascinating tools and devices used throughout history to measure our world.
                    From ancient Egyptian cubits to modern precision instruments.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
